import React from 'react';
import { Link } from 'react-router-dom'; // Link import edildi kanka
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="subtitle">Özel Koleksiyon</span>
          Tesbihin Sanatla <br /> Buluştuğu Nokta
        </h1>
        <p className="hero-description">
          Ateş kehribardan Osmanlı sıkmasına, usta işçilikli en nadide parçalar 
          Tesbihcimen Collection kalitesiyle mezat masasında.
        </p>
        <div className="hero-btns">
          {/* Koleksiyon linkine veya sayfa içi ID'ye yönlendiriyoruz */}
          <Link to="/urunler" className="btn-primary">Koleksiyonu İncele</Link>
          
          {/* Mezat takvimi için şimdilik bir placeholder veya dış link */}
          <button 
            className="btn-secondary" 
            onClick={() => window.open('https://www.tiktok.com/@tesbihcimen.collection?lang=tr-TR', '_blank')}
          >
            Canlı Mezat Takvimi
          </button>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default HeroSection;